import { render, staticRenderFns } from "./ItemDetailPremiumMarketLayout.vue?vue&type=template&id=c65a5a9a&scoped=true"
import script from "./ItemDetailPremiumMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailPremiumMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65a5a9a",
  null
  
)

export default component.exports